import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import ButtonBase from './ButtonBase';
import { ButtonBaseProps, ButtonState } from './button.types';
import { applyButtonStyles } from './button.utility';
import { useMemo } from 'react';
import { buttonStyleDefaultData } from './button.data';

type ButtonProps = ButtonBaseProps & {
  color?: string;
  state?: ButtonState;
};

function ButtonDiscreet({ children, color, state, ...rest }: ButtonProps) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary?.main;
  const paletteShallow =
    theme.buttonStyle?.discreet ||
    buttonStyleDefaultData({
      defaultColor: primaryColor,
      hoverColor: theme.palette.themeColor?.main,
      secondaryHoverColor: theme.palette.secondary.dark,
    }).discreet;
  const palette = JSON.parse(JSON.stringify(paletteShallow));

  if (color) {
    palette.textColor.default = color;
    palette.textColor.hover = color;
  }

  if (state === 'hover') {
    palette.background.default = palette.background.hover;
  }

  const themeOb = useMemo(() => {
    return createTheme({
      palette: {
        ...theme.palette,
        primary: {
          main: primaryColor,
          dark: primaryColor,
        },
      },
      components: {
        MuiButtonBase: {
          defaultProps: {
            disableRipple: true,
          },
          styleOverrides: {
            root: {
              height: palette.height,
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            text: {
              ...applyButtonStyles(palette),
              textTransform: 'none',
              fontFamily: theme.palette.primaryFontFamilyType,
              paddingLeft: '16px',
              paddingRight: '16px',
            },
          },
        },
      },
    });
  }, [state]);

  return (
    <ThemeProvider theme={themeOb}>
      <ButtonBase variant="discreet" {...rest}>
        {children}
      </ButtonBase>
    </ThemeProvider>
  );
}

export default ButtonDiscreet;
